import { render, staticRenderFns } from "./user-register.vue?vue&type=template&id=7d0faf78&"
import script from "./user-register.vue?vue&type=script&lang=js&"
export * from "./user-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports